import { render } from "./ImplantsEatAnything.vue?vue&type=template&id=1241db29"
import script from "./ImplantsEatAnything.vue?vue&type=script&lang=js"
export * from "./ImplantsEatAnything.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__